import httpClient from '@/api/http-client'

// import apiOrgstructure from '@/apps/org/api/anketa/index.js'

export default {

  /**
   * Получение списка постов.
   *
   * @param containers
   * @param posts
   * @returns {*}
   */
  getPosts( containers, posts ) {

    const data = {
      containers,
      posts
    }

    return httpClient.http
      .post( `/orgstructure/v1/posts-list`, data )
      .then( response => {
        return response.data
      } )
  },

  /**
   * Получение списка аккаунтов.
   *
   * @param posts
   * @returns {*}
   */
  getAccounts( posts ) {

    const postsIds = {
      posts_ids: posts
    }

    // return apiOrgstructure.orgschemeForms( postsIds );

    return httpClient.http
      .post( `/worksheet/v1/posts-forms`, postsIds )
      .then( response => {
        return response.data
      } )
  }
}



// WEBPACK FOOTER //
// ./src/components/BeingSelector/src/api/api.js